import FormikAutocomplete from "./FormikAutocomplete";
import FormikAddressSearch from "./FormikAddressSearch";
import FormikCheckbox from "./FormikCheckbox";
import FormikDatePicker from "./FormikDatePicker";
import FormikDateRangePicker from "./FormikDateRangePicker";
import FormikDateTimePicker from "./FormikDateTimePicker";
import FormikNumberField from "./FormikNumberField";
import FormikSubmitButton from "./FormikSubmitButton";
import FormikTextArea from "./FormikTextArea";
import FormikTextField from "./FormikTextField";
import FormikTimePicker from "./FormikTimePicker";

export const Inputs = {
  Text: FormikTextField,
  Submit: FormikSubmitButton,
  Date: FormikDatePicker,
  Dropdown: FormikAutocomplete,
  TextArea: FormikTextArea,
  Number: FormikNumberField,
  DateRange: FormikDateRangePicker,
  Checkbox: FormikCheckbox,
  DateTime: FormikDateTimePicker,
  Time: FormikTimePicker,
  Address: FormikAddressSearch,
};
